/**
 * @require ./tools.js
 */
(function (tools) {
    function getTypeName(element, root) {
        switch (element.Type) {
            case Enums.elementType.Root:
            case Enums.elementType.Location:
                return i18next.t('elementTypes.room');
            case Enums.elementType.ObjectTemplate:
                return i18next.t('elementTypes.item');
            case Enums.elementType.Form:
                return i18next.t('elementTypes.form');
            case Enums.elementType.CheckpointGroupTemplate:
                return i18next.t('elementTypes.testgroupTemplate');
            case Enums.elementType.MasterdataTemplate:
                return i18next.t('elementTypes.masterDataTemplate');
            case Enums.elementType.PropertyTemplate:
                return i18next.t('elementTypes.propertyTemplate');
            case Enums.elementType.Sensor:
                return i18next.t('elementTypes.sensor');
            case Enums.elementType.MasterdataGroup:
                return i18next.t('elementTypes.masterDataGroup');
            case Enums.elementType.FormHeader:
                return i18next.t('elementTypes.formHeader');
            case Enums.elementType.FormFooter:
                return i18next.t('elementTypes.formFooter');
            case Enums.elementType.SubsampleFormRow:
                return i18next.t('elementTypes.formRow');
            case Enums.elementType.SingletonFormRow:
                if (root &&
                    (root.Type === Enums.elementType.Form || root.Type === Enums.elementType.FormTemplate) &&
                    root.IsWeighted) {
                    return i18next.t('elementTypes.singleFormRow_weighted');
                }

                return i18next.t('elementTypes.singleFormRow');
            case Enums.elementType.Parametergroup:
                return i18next.t('elementTypes.testgroup');
            case Enums.elementType.Checkbox:
                return i18next.t('elementTypes.checkbox');
            case Enums.elementType.Number:
                if (element.RepresentationType &&
                    root &&
                    root.Type === Enums.elementType.Form &&
                    root.IsSurvey) {
                    switch (element.RepresentationType) {
                        case Enums.RepresentationType.SmileysHorizontal:
                            return i18next.t('formsOfRepresentation.smileysHorizontal');
                        case Enums.RepresentationType.SmileysVertical:
                            return i18next.t('formsOfRepresentation.smileysVertical');
                        case Enums.RepresentationType.Stars:
                            return i18next.t('formsOfRepresentation.stars');
                    }
                }

                return i18next.t('elementTypes.number');
            case Enums.elementType.Line:
                return i18next.t('elementTypes.line');
            case Enums.elementType.Memo:
                return i18next.t('elementTypes.memo');
            case Enums.elementType.Date:
                return i18next.t('elementTypes.date');
            case Enums.elementType.Time:
                return i18next.t('elementTypes.time');
            case Enums.elementType.Photo:
                return i18next.t('elementTypes.photo');
            case Enums.elementType.Scancode:
                return i18next.t('elementTypes.scancode');
            case Enums.elementType.LocationCode:
                return i18next.t('elementTypes.locationCode');
            case Enums.elementType.ListBox:
                return i18next.t('elementTypes.listbox');
            case Enums.elementType.MultiListBox:
                return i18next.t('elementTypes.multipleChoice');
            case Enums.elementType.Info:
                return i18next.t('elementTypes.info');
            case Enums.elementType.Print:
                return i18next.t('elementTypes.print');
            case Enums.elementType.Signature:
                return i18next.t('elementTypes.signature');
            case Enums.elementType.UsersAndTeams:
                return i18next.t('elementTypes.usersAndTeams');
            case Enums.elementType.PhoneNumber:
                return i18next.t('elementTypes.phoneNumber');
            case Enums.elementType.EMailAddresses:
                return i18next.t('elementTypes.emailAddresses');
            case Enums.elementType.IndividualData:
                if (element.AdditionalSettings) {
                    var schemas = IndividualData.GetSchemas();

                    var types = $.map(element.AdditionalSettings.Types || [], function (type) {
                        var schema = Tools.getFirst(schemas, type, 'Type');

                        return schema ? schema.NamePlural : null;
                    });

                    if (types.length) {
                        return types.join(', ');
                    }
                }

                return i18next.t('elementTypes.individualData');
            case Enums.elementType.Files:
                return i18next.t('elementTypes.files');
            default:
                return i18next.t('misc.unknown');
        }
    }

    function prepareAdditionalProperties(properties, prepareForPrint) {
        var propertyList = {};
        var groups = [];
        var property;
        var parent;

        if ((properties || []).length) {
            for (var pCnt = 0, pLen = properties.length; pCnt < pLen; pCnt++) {
                property = properties[pCnt];

                propertyList[property.OID] = $.extend(true, {}, property);
            }

            for (var oid in propertyList) {
                property = propertyList[oid];

                if (!!property.ParentOID) {
                    parent = propertyList[property.ParentOID];

                    if (!parent) {
                        continue;
                    }

                    parent.Children = parent.Children || [];
                    parent.Children.push(property);
                    property.Parent = parent;

                    parent.Children.sort(Tools.SortByPosition);
                } else {
                    groups.push(property);
                    groups.sort(Tools.SortByPosition);
                }

                property.Value = getAdditionalPropertyValue(property, prepareForPrint);
            }
        }

        return groups;
    }

    function getAdditionalPropertyValue(property, prepareForPrint, asStringValue) {
        if (property.Type !== Enums.additionalPropertyType.Checkbox
            && !property.Value) {
            return '-/-';
        }

        switch (property.Type) {
            case Enums.additionalPropertyType.Checkbox:
                if (property.Value === true) {
                    if (asStringValue) {
                        return i18next.t('misc.yes');
                    }

                    return '<img src="./img/checked.svg" width="{0}">'.format(prepareForPrint ? 25 : 50);
                } else if (property.Value === false) {
                    if (asStringValue) {
                        return i18next.t('misc.no');
                    }

                    return '<img src="./img/crosschecked.svg" width="{0}">'.format(prepareForPrint ? 25 : 50);
                } else {
                    if (asStringValue) {
                        return '-/-';
                    }

                    return '<img src="./img/unchecked.svg" width="{0}">'.format(prepareForPrint ? 25 : 50);
                }
            case Enums.additionalPropertyType.Date:
                return Tools.dateTime.dateToString(new Date(property.Value));
            case Enums.additionalPropertyType.Time:
                return Tools.dateTime.timeToString(new Date(property.Value));
            case Enums.additionalPropertyType.Image:
                if (asStringValue) {
                    return property.Value;
                }

                var file = Files[property.Value];

                if (!file) {
                    return '-/-';
                }

                return '<img src="{0}images/s/{1}" />'.format(Config.BaseUri, file.Filename);
            case Enums.additionalPropertyType.IndividualData:
                var selectedEntities = typeof property.Value === 'object' ?
                    property.Value[property.SubType] || [] :
                    [];

                var texts = $.map(selectedEntities, function (id) {
                    return IndividualData.GetEntityTitle(property.SubType, id);
                }).filter(function (title) {
                    return !!title;
                });

                texts.sort(Tools.SortStringArray);

                return texts.join('<br>') || '-/-';
        }

        return property.Value;
    }

    function hasCategory(category, element) {
        if (!category || !element ||
            !element.Evaluation || !element.Evaluation.length) {
            return false;
        }

        const categoryOID = typeof category === 'string' ? category : category.OID;

        for (let evaluation of element.Evaluation) {
            if (evaluation.CategoryOID === categoryOID) {
                return true;
            }
        }

        return false;
    }

    function isDescendant(descendant, ancestor) {
        if (!ancestor || !descendant) {
            return false;
        }

        const ancestorOID = typeof ancestor === 'string' ? ancestor : ancestor.OID;

        while (descendant) {
            if (descendant.OID === ancestorOID) {
                return true;
            }

            descendant = descendant.Parent;
        }

        return false;
    }

    function getElementPath(identifier, useModified, typeFilter) {
        var dataSource = useModified ? changemode.Elements : DataManager.OrganizationUnitLoader.Data.DataMap;
        var path;

        if (dataSource.hasOwnProperty(identifier)) {
            var parent = dataSource[identifier];

            if (!parent.Parent) {
                return '';
            }

            parent = parent.Parent;
            path = parent.Title;

            for (var i = 2; i > 0 && (parent = parent.Parent); i--) {
                if (typeFilter instanceof Array &&
                    typeFilter.indexOf(parent.Type) === -1) {
                    break;
                }

                path = '{0} &rsaquo; {1}'.format(parent.Title, path);
            }
        }

        return path;
    }

    function formatElementCoding(prefix, ident) {
        if (!prefix || !ident) {
            return null;
        }

        if (typeof ident === 'number') {
            ident = formatElementCodingIdent(ident);
        }

        return prefix + ident;
    }

    function formatElementCodingIdent(ident) {
        if (!ident) {
            return null;
        }

        return ('' + ident).padleft('0', 4);
    }

    function createElementHierarchy(elements) {
        if (!(elements instanceof Array)) {
            return null;
        }

        var map = elements.reduce(function (map, elem) {
            map[elem.OID] = elem;

            return map;
        }, {});

        var root;

        elements.forEach(function (elem) {
            var parentElement = map[elem.ParentOID];

            if (elem.ParentOID && !parentElement) {
                delete elem.ParentOID;
            }

            if (elem.Type === Enums.elementType.Form && parentElement && parentElement.Type === Enums.elementType.Root) {
                delete elem.ParentOID;
                parentElement = null;
            }

            if (!elem.ParentOID) {
                root = elem;
                return;
            }

            if (parentElement) {
                elem.Parent = parentElement;

                if (elem.Type >= Enums.elementType.Checkbox) {
                    // Prüfpunkte
                    parentElement.Parameters = parentElement.Parameters || [];
                    parentElement.Parameters.push(elem);
                    parentElement.Parameters.sort(Tools.SortByPosition);
                } else if (Tools.contains(Enums.elementType.AllGroups, elem.Type)) {
                    // Prüfgruppen
                    parentElement.Parametergroups = parentElement.Parametergroups || [];
                    parentElement.Parametergroups.push(elem);
                    parentElement.Parametergroups.sort(Tools.SortByPosition);
                } else if (elem.Type !== Enums.elementType.Root) {
                    // Der Rest
                    parentElement.Children = parentElement.Children || [];
                    parentElement.Children.push(elem);
                    parentElement.Children.sort(Tools.SortByPosition);
                }
            }
        });

        return root;
    }

    function createElementHierarchyString(element, addSelf = false) {
        if (!element) {
            return null;
        }

        const hierarchy = [];

        let parent = addSelf ? element : element.Parent;
        while (parent && parent.Type !== Enums.elementType.Root) {
            hierarchy.unshift(parent.Title);
            parent = parent.Parent;
        }

        return DOMPurify.sanitize(hierarchy.join(' » '));
    }

    function createHierarchyForDownloadedElements(elements, attachToOUs) {
        if (!(elements instanceof Array) || !elements.length) {
            return;
        }

        attachToOUs = attachToOUs || false;

        var cache = (elements || []).reduce(function (dict, element) {
            dict[element.OID] = Tools.Escape.Element(element);

            return dict;
        }, {});

        for (var oid in cache) {
            var element = cache[oid];

            if (!element.ParentOID) {
                continue;
            }

            var parent = cache[element.ParentOID] || DataManager.OrganizationUnitLoader.Data.DataMap[element.ParentOID];

            if (!parent) {
                continue;
            }

            element.Parent = parent;

            if (attachToOUs &&
                (parent.Type === Enums.elementType.Root || parent.Type === Enums.elementType.Location) &&
                element.Type === Enums.elementType.Parametergroup) {
                parent.Parametergroups = parent.Parametergroups || [];
                parent.Parametergroups.push(element);
                parent.Parametergroups.sort(Tools.SortByPosition);
            }

            if (parent.Type >= Enums.elementType.SingletonFormRow &&
                element.Type >= Enums.elementType.Checkbox) {
                parent.Children = parent.Children || [];
                parent.Children.push(element);
                parent.Children.sort(Tools.SortByPosition);
            }
        }

        return cache;
    }

    function getFromAdditionalSettings(element, settingsKey, defaultValue) {
        if (!element || !element.AdditionalSettings || !settingsKey) {
            return defaultValue;
        }

        return element.AdditionalSettings[settingsKey] || defaultValue;
    }

    /**
     * @param {[]} elements
     * @param {string} progressbarTextKey
     * @param {number} [batchSize=500]
     * @return {jQuery.Promise}
     */
    function modifyBatch(elements, progressbarTextKey, batchSize = 500) {
        const entities = [...elements].map(Tools.GetElementDataForService);

        return performBatchedRequest(entities, progressbarTextKey, 'modify', batchSize);
    }

    /**
     * @param {[]} elements
     * @param {string} progressbarTextKey
     * @param {number} [batchSize=500]
     * @return {jQuery.Promise}
     */
    function deleteBatch(elements, progressbarTextKey, batchSize = 500) {
        const identifiers = [...elements].map(e => e.OID);

        return performBatchedRequest(identifiers, progressbarTextKey, 'delete', batchSize);
    }

    /**
     * @private
     * @param {[]} entities
     * @param {string} progressbarTextKey
     * @param {'modify'|'delete'} action
     * @param {number} [batchSize=500]
     * @return {jQuery.Promise}
     */
    function performBatchedRequest(entities, progressbarTextKey, action = 'modify', batchSize = 500) {
        const $deferred = $.Deferred();

        if (!Array.isArray(entities) || !entities.length) {
            return $deferred.resolve().promise();
        }

        action = action.toLowerCase();

        if (isNaN(batchSize) || batchSize < 1) {
            batchSize = 500;
        }

        Tools.Progressbar.Start(
            Math.ceil(entities.length / batchSize),
            i18next.t(`progressbar.${progressbarTextKey}`),
            $.noop,
            true
        );

        const uri = `elements/${action}`;
        const isModifyAction = action === 'modify';
        const isDeleteAction = action === 'delete';

        (function loop() {
            const batch = entities.splice(0, batchSize);

            if (batch.length) {
                Tools.Progressbar.StartProgress();

                Tools.http.post(uri, batch)
                    .done(function () {
                        batch.forEach(item => {
                            const element = isModifyAction ?
                                changemode.Elements[item.OID] :
                                changemode.Elements[item];

                            if (element == null) {
                                return;
                            }

                            if (isModifyAction) {
                                if (element.ModificationType === Enums.ModificationType.NotModified) {
                                    element.ModificationType = Enums.ModificationType.Edited;
                                }
                            } else if (isDeleteAction) {
                                element.ModificationType = Enums.ModificationType.Deleted;
                            }
                        });

                        loop();
                        Tools.Progressbar.StopProgress();
                    })
                    .fail(function (xhr) {
                        Tools.handleHttpError(Enums.HttpActionType.Write, xhr);
                        Tools.Progressbar.Stop();
                        Tools.Spinner.hide();

                        $deferred.reject();
                    });
            } else {
                Tools.Progressbar.Stop();
                $deferred.resolve();
            }
        })();

        return $deferred.promise();
    }

    /**
     * @param {*} element
     * @param {string} attributeName
     * @param {('boolean'|'number|'property'|'properties'|'color'|'string-list'|'element-list'|'element-type'|'attribute'|'roles'|'teams'|'barcode-type'|'suggested-values'|'structure'|'representation-type'|'formula'|'filter-formula'|'cp-print-code-type'|'cp-print-media-type'|'html'|'files'|'evaluation'|'workflows'|'requirements'|'temporary-deviation')} type
     * @param {boolean} [useModifiedData=true]
     * @param {*?} additionalData
     * @return {string}
     */
    function renderElementAttributeValueToHtml(element, attributeName, type, useModifiedData = true, additionalData) {
        if (element == null || attributeName == null) {
            return '-/-';
        }

        element = Tools.clone(element, [ 'Parametergroups', 'Parameters', 'Children', 'Derivations', 'Parent', 'Processes' ]);

        const value = Tools.GetValueByPath(attributeName, element);
        let html;

        switch (type) {
            case 'boolean':
                html = boolToHtml(value);
                break;
            case 'number':
                return value == null || isNaN(value) ? '-/-' : value;
            case 'property':
                html = propertyToHtml(value, useModifiedData);
                break;
            case 'properties':
                html = propertyListToHtml(value, useModifiedData);
                break;
            case 'color':
                html = colorToHtml(value);
                break;
            case 'string-list':
                html = stringListToHtml(value);
                break;
            case 'element-list':
                html = elementListToHtml(value);
                break;
            case 'element-type':
                html = getTypeName(element, element.Type >= 100 ? element.Parent : element.Parent.Parent);
                break;
            case 'attribute':
                html = elementAttributeToHtml(value);
                break;
            case 'roles':
                html = rolesToHtml(value, useModifiedData);
                break;
            case 'teams':
                html = teamsToHtml(value, useModifiedData);
                break;
            case 'barcode-type':
                html = content.parameters.getBarcodeTypeTitle(value) || '-/-';
                break;
            case 'suggested-values':
                html = suggestedValuesToHtml(value);
                break;
            case 'structure':
                html = structureToHtml(element, value, useModifiedData);
                break;
            case 'representation-type':
                html = representationTypeToHtml(value);
                break;
            case 'formula':
                html = FormulaEditor.convertExpressionToHtml(value, FormulaEditor.Context.CheckpointValue) || '-/-';
                break;
            case 'filter-formula':
                html = FormulaEditor.convertExpressionToHtml(value, FormulaEditor.Context.IndividualdataFilter) || '-/-';
                break;
            case 'cp-print-code-type':
                html = checkpointPrintCodeTypeToHtml(value);
                break;
            case 'cp-print-media-type':
                html = checkpointMediaTypeToHtml(value);
                break;
            case 'files':
                html = fileListToHtml(value, useModifiedData);
                break;
            case 'evaluation':
                html = evaluationListToHtml(element, value, useModifiedData);
                break;
            case 'workflows':
                html = workflowsToHtml(value, useModifiedData);
                break;
            case 'requirements':
                html = requirementsToHtml(value, additionalData, useModifiedData);
                break;
            case 'temporary-deviation':
                html = temporaryDeviationToHtml(value);
                break;
            case 'html':
                html = value || '-/-';
                break;
            default:
                html = (value || '-/-').replace(/\r?\n|\r/g, '<br />');
        }

        return DOMPurify.sanitize(html);
    }

    function boolToHtml(value) {
        return value == null
            ? '<input type="checkbox" disabled>'
            : (!!value
                ? '<input type="checkbox" disabled checked>'
                : '<input type="checkbox" disabled>');
    }

    function propertyListToHtml(properties, useModifiedData) {
        if (!(properties instanceof Array) || !properties.length) {
            return '-/-';
        }

        return `<ul>
                    ${properties
                        .map(function (oid) {
                            const property = useModifiedData ? changemode.Properties[oid] : Properties[oid];

                            if (!property || property.ModificationType === Enums.ModificationType.Deleted) {
                                return null;
                            }

                            return property.Title;
                        })
                        .filter(property => !!property)
                        .sort(Tools.SortStringArray)
                        .map(title => `<li>${title}</li>`)
                        .join('')}
                </ul>`;
    }

    function propertyToHtml(value, useModifiedData) {
        if (!value) {
            return '-/-';
        }

        const status = useModifiedData ? changemode.Properties[value] : Properties[value];
        const color = (status || {}).Color || '#7E1210';
        const title = (status || {}).Title || i18next.t('misc.unknown')

        return colorToHtml(color, false) + `<span>${title}</span>`;
    }

    function colorToHtml(value, withColorCode) {
        if (!value) {
            return '-/-';
        }

        let html = `<span class="color" style="background-color: ${value}"></span>`;

        if (withColorCode) {
            html += ` ${value}`;
        }

        return html;
    }

    function stringListToHtml(value) {
        return value instanceof Array ? value.join(', ') : '-/-';
    }

    function elementListToHtml(value) {
        if (!(value instanceof Array) || !value.length) {
            return '-/-';
        }

        return `<ul>
                    ${value
                        .map(function (oid) {
                            const element = changemode.Elements[oid];

                            if (!element || element.ModificationType === Enums.ModificationType.Deleted) {
                                return null;
                            }

                            return element.Title;
                        })
                        .filter(element => !!element)
                        .sort(Tools.SortStringArray)
                        .map(title => `<li>${title}</li>`)
                        .join('')}
                </ul>`;
    }

    function elementAttributeToHtml(attribute) {
        if (attribute === 4) {
            return i18next.t('changeMode.panels.properties.attributes.conditions');
        }

        return attribute === 5 ? i18next.t('changeMode.panels.properties.attributes.measure') : '-/-';
    }

    function rolesToHtml(roles, useModifiedData) {
        if (!(roles instanceof Array) || !roles.length) {
            return '-/-';
        }

        return `<ul>
                    ${roles
                        .map(function (oid) {
                            const role = useModifiedData ? changemode.Roles[oid] : Roles[oid];

                            if (!role || role.ModificationType === Enums.ModificationType.Deleted) {
                                return null;
                            }

                            return role.Title;
                        })
                        .filter(role => !!role)
                        .sort(Tools.SortStringArray)
                        .map(title => `<li>${title}</li>`)
                        .join('')}
                </ul>`;
    }

    function teamsToHtml(teams, useModifiedData) {
        if (!(teams instanceof Array) || !teams.length) {
            return '-/-';
        }

        return `<ul>
                    ${teams
                        .map(function (oid) {
                            const team = useModifiedData ? changemode.Teams[oid] : Teams[oid];

                            if (!team || team.ModificationType === Enums.ModificationType.Deleted) {
                                return null;
                            }

                            return team.Title;
                        })
                        .filter(team => !!team)
                        .sort(Tools.SortStringArray)
                        .map(title => `<li>${title}</li>`)
                        .join('')}
                </ul>`;
    }

    function suggestedValuesToHtml(suggestedValues) {
        if (!(suggestedValues instanceof Array)) {
            return '-/-';
        }

        const values = suggestedValues.sort(Tools.SortByPosition).map(v => v.Value);

        return `<ul>${values.map(v => `<li>${v}</li>`).join('')}</ul>`;
    }

    function structureToHtml(element, useModifiedData) {
        if (!element.Structure) {
            return '-/-';
        }

        const mapStructureToImages = (element.AdditionalSettings || {}).MapStructureToImages;

        const values = Object
            .keys(element.Structure)
            .map(function (k) {
                const v = element.Structure[k];
                const key = parseInt(k, 10) || 0;

                if (mapStructureToImages) {
                    const file = useModifiedData ? changemode.Files[v] : Files[v];

                    if (file) {
                        return {
                            Key: key,
                            Value: file.Title,
                            Rating: (element.StructureEval || {})[k]
                        };
                    }
                }

                return {
                    Key: key,
                    Value: v,
                    Rating: (element.StructureEval || {})[k]
                };
            });

        if (!values || !values.length) {
            return '-/-';
        }

        return `
        <ul>
            ${values.map(function (v) {
                const value = v.Rating == null || v.Rating === '' ?
                    v.Value :
                    `${v.Value} (${v.Rating})`;

                return `<li>${value}</li>`;
            }).join('')}
        </ul>`;
    }

    function representationTypeToHtml(representationType) {
        switch (representationType) {
            case Enums.RepresentationType.SmileysHorizontal:
                return i18next.t('formsOfRepresentation.smileysHorizontal');
            case Enums.RepresentationType.SmileysVertical:
                return i18next.t('formsOfRepresentation.smileysVertical');
            case Enums.RepresentationType.Stars:
                return i18next.t('formsOfRepresentation.stars');
        }

        return i18next.t('elementTypes.number');
    }

    function checkpointPrintCodeTypeToHtml(printCodeType) {
        switch (printCodeType) {
            case 'QR':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.types.QR');
            case 'CODE128':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.types.CODE128');
            case 'CODE39':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.types.CODE39');
            case 'EAN13':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.types.EAN13');
            case 'CUSTOM':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.types.CUSTOM');
        }

        return i18next.t('misc.unknown');
    }

    function checkpointMediaTypeToHtml(mediaType) {
        switch (mediaType) {
            case 'continuous':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.mediaTypes.continuous');
            case 'marked':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.mediaTypes.marked');
            case 'default':
                return i18next.t('changeMode.parameterWindow.panels.printSettings.mediaTypes.default');
        }

        return i18next.t('misc.unknown');
    }

    function fileListToHtml(files, useModifiedData) {
        if (!(files instanceof Array) || !files.length) {
            return '-/-';
        }

        files = [...files];

        return `<ol>
                    ${files
                        .map(function (file) {
                            const catalogueFile = useModifiedData ? changemode.Files[file.OID] : Files[file.OID];

                            if (!catalogueFile || catalogueFile.ModificationType === Enums.ModificationType.Deleted) {
                                return null;
                            }

                            file.File = catalogueFile;

                            return file;
                        })
                        .filter(file => !!file)
                        .sort(Tools.SortByPosition)
                        .map(file => {
                            return `<li>${!!file.Prioritize ? `<strong>` : ''}${file.File.Title}${!!file.Prioritize ? `</strong>` : ''}</li>`;
                        })
                        .join('')}
                </ol>`;
    }

    function evaluationListToHtml(element, evaluation, useModifiedData = true) {
        function prepare(valueRange) {
            valueRange.Position = valueRange.Position || valueRange.Order || 0;
            valueRange.Category = useModifiedData ?
                changemode.Properties[valueRange.CategoryOID] :
                Properties[valueRange.CategoryOID];

            return valueRange;
        }

        function compare(a, b) {
            if (a.CategoryOID === b.CategoryOID) {
                return a.Position === b.Position ?
                    Tools.SortAlphaNumeric(a.OID || '', b.OID || '') :
                    Tools.SortByPosition(a, b);
            }

            return a.Category && b.Category &&
                a.Category.Position !== b.Category.Position ?
                    Tools.SortByPosition(a.Category, b.Category) :
                    Tools.SortAlphaNumeric(a.CategoryOID, b.CategoryOID);
        }

        if (!(evaluation instanceof Array) || !evaluation.length) {
            return '-/-';
        }

        let html;

        evaluation
            .filter(eva => eva.Type === element.Type)
            .map(prepare)
            .sort(compare)
            .forEach(function (valueRange) {
                if (html) {
                    html += '<br>';
                } else {
                    html = '';
                }

                html += evaluationToHtml(element, valueRange);
            });

        return html;
    }

    function evaluationToHtml(element, valueRange, useModifiedData = true) {
        const operators = { eq: 0, ne: 1, lt: 2, le: 3, gt: 4, ge: 5 };
        let value, firstOperator, firstValue, secondOperator, secondValue;
        let html = colorToHtml((valueRange.Category || {}).Color || '#7E1210') +
            ((valueRange.Category || {}).Title || i18next.t('misc.unknown')) +
            ': ';

        switch (valueRange.Type) {
            case Enums.elementType.Checkbox:
                switch (valueRange.Value) {
                    case 1:
                        html += i18next.t('misc.yes');
                        break;
                    case 2:
                        html += i18next.t('misc.no');
                        break;
                    default:
                        html += i18next.t('misc.notRecorded');
                        break;
                }
                break;
            case Enums.elementType.Number:
                firstOperator = valueRange.FirstOperator || 0;
                firstValue = parseFloat(valueRange.FirstValue) || 0;

                if (valueRange.SecondOperator) {
                    secondOperator = valueRange.SecondOperator;
                    secondValue = parseFloat(valueRange.SecondValue) || 0;
                }

                switch (firstOperator) {
                    case operators.eq:
                        html += '= ';
                        html += firstValue;
                        break;
                    case operators.ne:
                        html += '≠ ';
                        html += firstValue;
                        break;
                    case operators.lt:
                        html += '< ';
                        html += firstValue;
                        break;
                    case operators.le:
                        html += '≤ ';
                        html += firstValue;
                        break;
                    case operators.gt:
                        html += '> ';
                        html += firstValue;
                        break;
                    case operators.ge:
                        html += '≥ ';
                        html += firstValue;
                        break;
                }

                if (Tools.contains([ operators.lt, operators.le, operators.gt, operators.ge ], secondOperator)) {
                    switch (firstOperator) {
                        case operators.lt:
                        case operators.le:
                            html += ' ';

                            if (firstValue > secondValue) {
                                html += i18next.t('changeMode.panels.info.historyProperties.to', { context: 'lowercase' });
                            } else {
                                html += i18next.t('changeMode.panels.info.historyProperties.or');
                            }

                            html += ' ';
                            break;
                        case operators.gt:
                        case operators.ge:
                            html += ' ';

                            if (firstValue < secondValue) {
                                html += i18next.t('changeMode.panels.info.historyProperties.to', { context: 'lowercase' });
                            } else {
                                html += i18next.t('changeMode.panels.info.historyProperties.or');
                            }

                            html += ' ';
                            break;
                    }

                    switch (secondOperator) {
                        case operators.lt:
                            html += '< ';
                            html += secondValue;
                            break;
                        case operators.le:
                            html += '≤ ';
                            html += secondValue;
                            break;
                        case operators.gt:
                            html += '> ';
                            html += secondValue;
                            break;
                        case operators.ge:
                            html += '≥ ';
                            html += secondValue;
                            break;
                    }
                }
                break;
            case Enums.elementType.Date:
                firstOperator = valueRange.FirstOperator || 0;
                firstValue = parseFloat(valueRange.FirstValue) || 0;

                if (valueRange.SecondOperator) {
                    secondOperator = valueRange.SecondOperator;
                    secondValue = parseFloat(valueRange.SecondValue) || 0;
                }

                switch (valueRange.ValueType) {
                    case 0:
                        html += i18next.t('changeMode.panels.info.historyProperties.ageInDays');
                        html += ' ';
                        break;
                    case 1:
                        html += i18next.t('changeMode.panels.info.historyProperties.ageInMonths');
                        html += ' ';
                        break;
                    case 2:
                        html += i18next.t('changeMode.panels.info.historyProperties.ageInYears');
                        html += ' ';
                        break;
                }

                switch (firstOperator) {
                    case operators.eq:
                        html += '= ';
                        html += firstValue;
                        break;
                    case operators.ne:
                        html += '≠ ';
                        html += firstValue;
                        break;
                    case operators.lt:
                        html += '< ';
                        html += firstValue;
                        break;
                    case operators.le:
                        html += '≤ ';
                        html += firstValue;
                        break;
                    case operators.gt:
                        html += '> ';
                        html += firstValue;
                        break;
                    case operators.ge:
                        html += '≥ ';
                        html += firstValue;
                        break;
                }

                if (Tools.contains([ operators.lt, operators.le, operators.gt, operators.ge ], secondOperator)) {
                    switch (firstOperator) {
                        case operators.lt:
                        case operators.le:
                            html += ' ';

                            if (firstValue > secondValue) {
                                html += i18next.t('changeMode.panels.info.historyProperties.to', { context: 'lowercase' });
                            } else {
                                html += i18next.t('changeMode.panels.info.historyProperties.or');
                            }

                            html += ' ';
                            break;
                        case operators.gt:
                        case operators.ge:
                            html += ' ';

                            if (firstValue < secondValue) {
                                html += i18next.t('changeMode.panels.info.historyProperties.to', { context: 'lowercase' });
                            } else {
                                html += i18next.t('changeMode.panels.info.historyProperties.or');
                            }

                            html += ' ';
                            break;
                    }

                    switch (secondOperator) {
                        case operators.lt:
                            html += '< ';
                            html += secondValue;
                            break;
                        case operators.le:
                            html += '≤ ';
                            html += secondValue;
                            break;
                        case operators.gt:
                            html += '> ';
                            html += secondValue;
                            break;
                        case operators.ge:
                            html += '≥ ';
                            html += secondValue;
                            break;
                    }
                }
                break;
            case Enums.elementType.Time:
                firstOperator = valueRange.FirstOperator || 0;
                firstValue = parseFloat(valueRange.FirstValue) || 0;

                if (valueRange.SecondOperator) {
                    secondOperator = valueRange.SecondOperator;
                    secondValue = parseFloat(valueRange.SecondValue) || 0;
                }

                switch (valueRange.ValueType) {
                    case 0:
                        html += i18next.t('changeMode.panels.info.historyProperties.ageInSeconds');
                        html += ' ';
                        break;
                    case 1:
                        html += i18next.t('changeMode.panels.info.historyProperties.ageInMinutes');
                        html += ' ';
                        break;
                    case 2:
                        html += i18next.t('changeMode.panels.info.historyProperties.ageInHours');
                        html += ' ';
                        break;
                }

                switch (firstOperator) {
                    case operators.eq:
                        html += '= ';
                        html += firstValue;
                        break;
                    case operators.ne:
                        html += '≠ ';
                        html += firstValue;
                        break;
                    case operators.lt:
                        html += '< ';
                        html += firstValue;
                        break;
                    case operators.le:
                        html += '≤ ';
                        html += firstValue;
                        break;
                    case operators.gt:
                        html += '> ';
                        html += firstValue;
                        break;
                    case operators.ge:
                        html += '≥ ';
                        html += firstValue;
                        break;
                }

                if (Tools.contains([ operators.lt, operators.le, operators.gt, operators.ge ], secondOperator)) {
                    switch (firstOperator) {
                        case operators.lt:
                        case operators.le:
                            html += ' ';

                            if (firstValue > secondValue) {
                                html += i18next.t('changeMode.panels.info.historyProperties.to', { context: 'lowercase' });
                            } else {
                                html += i18next.t('changeMode.panels.info.historyProperties.or');
                            }

                            html += ' ';
                            break;
                        case operators.gt:
                        case operators.ge:
                            html += ' ';

                            if (firstValue < secondValue) {
                                html += i18next.t('changeMode.panels.info.historyProperties.to', { context: 'lowercase' });
                            } else {
                                html += i18next.t('changeMode.panels.info.historyProperties.or');
                            }

                            html += ' ';
                            break;
                    }

                    switch (secondOperator) {
                        case operators.lt:
                            html += '< ';
                            html += secondValue;
                            break;
                        case operators.le:
                            html += '≤ ';
                            html += secondValue;
                            break;
                        case operators.gt:
                            html += '> ';
                            html += secondValue;
                            break;
                        case operators.ge:
                            html += '≥ ';
                            html += secondValue;
                            break;
                    }
                }
                break;
            case Enums.elementType.ListBox:
                value = (element.Structure || {})[valueRange.Value];

                if (value) {
                    const mapStructureToImages = (element.AdditionalSettings || {}).MapStructureToImages;

                    if (mapStructureToImages) {
                        const file = useModifiedData ? changemode.Files[value] : Files[value];

                        if (file) {
                            html += file.Title;
                        }
                    } else {
                        html += value;
                    }
                }
                break;
            default:
                if (!valueRange.Value) {
                    html += i18next.t('misc.recorded');
                } else {
                    html += i18next.t('misc.notRecorded');
                }
                break;
        }

        return html;
    }

    function workflowsToHtml(workflows, useModifiedData = true) {
        if (!useModifiedData) {
            return 'NOT YET SUPPORTED';
        }

        function prepareWorkflow(workflow) {
            workflow.Category = useModifiedData ?
                changemode.Properties[workflow.CategoryOID] :
                Properties[workflow.CategoryOID];

            return workflow;
        }

        function compareWorkflows(a, b) {
            if (a.CategoryOID === b.CategoryOID ||
                a.Type === Enums.elementActionType.OverdueNotification ||
                b.Type === Enums.elementActionType.OverdueNotification)
            {
                return a.Type === b.Type ?
                    Tools.SortAlphaNumeric(a.OID, b.OID) :
                    a.Type - b.Type;
            }

            return a.Category && b.Category &&
                a.Category.Position !== b.Category.Position ?
                    Tools.SortByPosition(a.Category, b.Category) :
                    Tools.SortAlphaNumeric(a.Category.OID, b.Category.OID);
        }

        if (!(workflows instanceof Array) || !workflows.length) {
            return '-/-';
        }

        return `<ul>
                    ${workflows
                        .map(prepareWorkflow)
                        .sort(compareWorkflows)
                        .map((workflow) => workflowToHtml(workflow, useModifiedData))
                        .join('')}
                </ul>`;
    }

    function workflowToHtml(workflow, useModifiedData = true) {
        const html = ['<li>'];

        if (workflow.Type !== Enums.elementActionType.OverdueNotification) {
            html.push(
                colorToHtml((workflow.Category || {}).Color || '#7E1210'),
                '<span>',
                ((workflow.Category || {}).Title || i18next.t('misc.unknown')),
                ': </span>'
            );
        }

        const triggerText = `${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.triggerAutomatically')}: ${workflow.TriggerAutomatically ? i18next.t('misc.yes') : i18next.t('misc.no')}`;

        switch (workflow.Type) {
            case Enums.elementActionType.Notification:
                const users = (workflow.Users || []).map(function (oid) {
                    const user = useModifiedData ? changemode.Users[oid] : Users[oid];

                    return (user || {}).Title || i18next.t('misc.unknown');
                });

                const teams = (workflow.Teams || []).map(function (oid) {
                    const team = useModifiedData ? changemode.Teams[oid] : Teams[oid];

                    return (team || {}).Title || i18next.t('misc.unknown');
                });

                const mailTemplate = !!workflow.MailTemplateOID ?
                    changemode.MailTemplates[workflow.MailTemplateOID] :
                    null;

                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.email'),
                    ' – ',
                    users.concat(teams).join(', '),
                    `<br>${triggerText}`
                );

                if (mailTemplate && mailTemplate.ModificationType !== Enums.ModificationType.Deleted) {
                    html.push(`<br>${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.mailTemplate')}: ${mailTemplate.Title}`);
                }
                break;
            case Enums.elementActionType.Form:
                const form = useModifiedData ? changemode.Elements[workflow.FormOID] : Elements[workflow.FormOID];

                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.form'),
                    ' – ',
                    (form || {}).Title || i18next.t('misc.unknown'),
                    `<br>${triggerText}`
                );
                break;
            case Enums.elementActionType.Measure:
                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.measure'),
                    ' – ',
                    workflow.Text || '',
                    `<br>${triggerText}`
                );
                break;
            case Enums.elementActionType.Comment:
                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.comment'),
                    ' – ',
                    workflow.Text || '',
                    `<br>${triggerText}`
                );
                break;
            case Enums.elementActionType.Photo:
                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.photo'),
                    `<br>${triggerText}`
                );
                break;
            case Enums.elementActionType.OverdueNotification:
                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.overdueNotification'),
                    `<br>${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.interval')}: `
                );

                switch (workflow.IntervalType) {
                    case 0:
                        html.push(i18next.t('changeMode.panels.info.historyProperties.workflowSettings.minute', {
                            count: workflow.MaximumInterval
                        }));
                        break;
                    case 1:
                        html.push(i18next.t('changeMode.panels.info.historyProperties.workflowSettings.hour', {
                            count: workflow.MaximumInterval
                        }));
                        break;
                    case 2:
                        html.push(i18next.t('changeMode.panels.info.historyProperties.workflowSettings.day', {
                            count: workflow.MaximumInterval
                        }));
                        break;
                }

                const userIdentifiers = (workflow.Users || [])
                    .filter(function (oid) {
                        const user = useModifiedData ? changemode.Users[oid] : Users[oid];

                        return user && user.ModificationType !== Enums.ModificationType.Deleted;
                    })
                    .sort(function (oidA, oidB) {
                        const userA = useModifiedData ? changemode.Users[oidA] : Users[oidA];
                        const userB = useModifiedData ? changemode.Users[oidB] : Users[oidB];

                        return Tools.SortByLastnameThenFirstname(userA, userB);
                    });

                if ((userIdentifiers || []).length) {
                    html.push(
                        '<p class="recipients users">',
                        userIdentifiers.map(function(oid) {
                            const user = useModifiedData ? changemode.Users[oid] : Users[oid];

                            return Tools.escapeHtml(user.Title);
                        }).join(', '),
                        '</p>'
                    );
                }

                const teamIdentifiers = (workflow.Teams || [])
                    .filter(function (oid) {
                        const team = useModifiedData ? changemode.Teams[oid] : Teams[oid];

                        return team && team.ModificationType !== Enums.ModificationType.Deleted;
                    })
                    .sort(function (oidA, oidB) {
                        const teamA = useModifiedData ? changemode.Teams[oidA] : Teams[oidA];
                        const teamB = useModifiedData ? changemode.Teams[oidB] : Teams[oidB];

                        return Tools.SortByTitle(teamA, teamB);
                    });

                if ((teamIdentifiers || []).length) {
                    html.push(
                        '<p class="recipients teams">',
                        teamIdentifiers.map(function(oid) {
                            const team = useModifiedData ? changemode.Teams[oid] : Teams[oid];

                            return Tools.escapeHtml(team.Title);
                        }).join(', '),
                        '</p>'
                    );
                }

                if (Tools.IsContactModuleAvailable()) {
                    const contactIdentifiers = (workflow.Contacts || [])
                        .filter(function (oid) {
                            const contact = useModifiedData ? changemode.Contacts[oid] : Contacts[oid];

                            return contact && contact.ModificationType !== Enums.ModificationType.Deleted;
                        })
                        .sort(function (oidA, oidB) {
                            const contactA = useModifiedData ? changemode.Contacts[oidA] : Contacts[oidA];
                            const contactB = useModifiedData ? changemode.Contacts[oidB] : Contacts[oidB];

                            return Tools.SortByTitle(contactA, contactB);
                        });

                    if ((contactIdentifiers || []).length) {
                        html.push(
                            '<p class="recipients contacts">',
                            contactIdentifiers.map(function(oid) {
                                const contact = useModifiedData ? changemode.Contacts[oid] : Contacts[oid];

                                return Tools.escapeHtml(contact.Title);
                            }).join(', '),
                            '</p>'
                        );
                    }

                    const contactGroupIdentifiers = (workflow.ContactGroups || [])
                        .filter(function (oid) {
                            const contactGroup = useModifiedData ? changemode.ContactGroups[oid] : ContactGroups[oid];

                            return contactGroup && contactGroup.ModificationType !== Enums.ModificationType.Deleted;
                        })
                        .sort(function (oidA, oidB) {
                            const contactGroupA = useModifiedData ? changemode.ContactGroups[oidA] : ContactGroups[oidA];
                            const contactGroupB = useModifiedData ? changemode.ContactGroups[oidB] : ContactGroups[oidB];

                            return Tools.SortByTitle(contactGroupA, contactGroupB);
                        });

                    if ((contactGroupIdentifiers || []).length) {
                        html.push(
                            '<p class="recipients contact-groups">',
                            contactGroupIdentifiers.map(function(oid) {
                                const contactGroup = useModifiedData ? changemode.ContactGroups[oid] : ContactGroups[oid];

                                return Tools.escapeHtml(contactGroup.Title);
                            }).join(', '),
                            '</p>'
                        );
                    }
                }

                if (Tools.IsEMailCpEnabled()) {
                    const mailCheckpointIdentifiers = (workflow.MailCheckpoints || [])
                        .filter(function (oid) {
                            const checkpoint = useModifiedData ? changemode.Elements[oid] : Elements[oid];

                            return checkpoint && checkpoint.ModificationType !== Enums.ModificationType.Deleted;
                        })
                        .sort(function (oidA, oidB) {
                            const checkpointA = useModifiedData ? changemode.Elements[oidA] : Elements[oidA];
                            const checkpointB = useModifiedData ? changemode.Elements[oidB] : Elements[oidB];

                            return Tools.SortByTitle(checkpointA, checkpointB);
                        });

                    if ((mailCheckpointIdentifiers || []).length) {
                        html.push(
                            '<p class="recipients mail-checkpoints">',
                            mailCheckpointIdentifiers.map(function(oid) {
                                const checkpoint = useModifiedData ? changemode.Elements[oid] : Elements[oid];

                                return Tools.escapeHtml(checkpoint.Title);
                            }).join(', '),
                            '</p>'
                        );
                    }
                }

                break;
            case Enums.elementActionType.ModifyParentIssue:
                html.push(
                    i18next.t('changeMode.panels.info.historyProperties.modifyParentIssue'),
                    `<br>${triggerText}`
                );

                if (workflow.ParentIssueModifications) {
                    html.push('<ul>');

                    for (const modification of workflow.ParentIssueModifications) {
                        let previousEntities;
                        let newEntities;
                        let propertyName;

                        if (modification.Property === 'Keywords') {
                            propertyName = i18next.t('changeMode.panels.info.historyProperties.workflowSettings.properties.keywords');

                            previousEntities = (modification.PreviousEntities || [])
                                .filter(identifier => {
                                    const property = useModifiedData ?
                                        changemode.Properties[identifier] :
                                        Properties[identifier];

                                    return property && property.ModificationType !== Enums.ModificationType.Deleted;
                                })
                                .map(identifier => {
                                    const property = useModifiedData ?
                                        changemode.Properties[identifier] :
                                        Properties[identifier];

                                    return property ? property.Title : null;
                                })
                                .sort(Tools.SortStringArray)
                                .join(', ');

                            newEntities = (modification.NewEntities || [])
                                .filter(identifier => {
                                    const property = useModifiedData ?
                                        changemode.Properties[identifier] :
                                        Properties[identifier];

                                    return property && property.ModificationType !== Enums.ModificationType.Deleted;
                                })
                                .map(identifier => {
                                    const property = useModifiedData ?
                                        changemode.Properties[identifier] :
                                        Properties[identifier];

                                    return property ? property.Title : null;
                                })
                                .sort(Tools.SortStringArray)
                                .join(', ');
                        }

                        let modificationType = i18next.t('misc.unknown');

                        switch (modification.Type) {
                            case Enums.elementActionIssueModificationType.Add:
                                previousEntities = '-/-';
                                modificationType = i18next.t('changeMode.panels.info.historyProperties.workflowSettings.modificationType.new');
                                break;
                            case Enums.elementActionIssueModificationType.Replace:
                                modificationType = i18next.t('changeMode.panels.info.historyProperties.workflowSettings.modificationType.replace');
                                break;
                            case Enums.elementActionIssueModificationType.ReplaceAll:
                                previousEntities = '-/-';
                                modificationType = i18next.t('changeMode.panels.info.historyProperties.workflowSettings.modificationType.replaceAll');
                                break;
                            case Enums.elementActionIssueModificationType.Remove:
                                newEntities = '-/-';
                                modificationType = i18next.t('changeMode.panels.info.historyProperties.workflowSettings.modificationType.remove');
                                break;
                        }

                        html.push(
                            '<li>',
                                `${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.propertyName')}: ${propertyName}<br>`,
                                `${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.modificationType.caption')}: ${modificationType}<br>`,
                                `${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.previousEntities')}: ${previousEntities}<br>`,
                                `${i18next.t('changeMode.panels.info.historyProperties.workflowSettings.newEntities')}: ${newEntities}`,
                            '</li>'
                        );
                    }

                    html.push('</ul>');
                }
                break;
        }

        html.push('</li>');

        return html.join('');
    }

    function requirementsToHtml(requirements, elements, useModifiedData = true) {
        if (!useModifiedData) {
            return 'NOT YET SUPPORTED';
        }

        function prepareCriterion(criterion) {
            criterion.Element = elements ?
                elements[criterion.ElementOID] :
                useModifiedData ? changemode.Elements[criterion.ElementOID] : null;

            criterion.Category = useModifiedData ?
                changemode.Properties[criterion.CategoryOID] :
                Properties[criterion.CategoryOID];

            return criterion;
        }

        if (!requirements ||
            !requirements.Criteria ||
            !requirements.Criteria.length) {
            return '-/-';
        }

        const html = [];

        switch (requirements.Type) {
            case Enums.elementRequirementsType.All:
                html.push(
                    '<u>',
                    i18next.t('changeMode.panels.info.historyProperties.requirements_all'),
                    ':</u>'
                );
                break;
            case Enums.elementRequirementsType.None:
                html.push(
                    '<u>',
                    i18next.t('changeMode.panels.info.historyProperties.requirements_none'),
                    ':</u>'
                );
                break;
            default:
                html.push(
                    '<u>',
                    i18next.t('changeMode.panels.info.historyProperties.requirements_any'),
                    ':</u>'
                );
                break;
        }

        html.push(
            '<ul>',
                requirements.Criteria
                    .map(prepareCriterion)
                    .map(criterionToHtml)
                    .join(''),
            '</ul>'
        );

        return html.join('');
    }

    function criterionToHtml(criterion) {
        const element = criterion.Element;
        const parentElement = element ? element.Parent : null;
        const category = criterion.Category;
        const html = ['<li>'];

        if (parentElement && element) {
            html.push(
                parentElement.Title || i18next.t('misc.unknown'),
                ' » ',
                element.Title || i18next.t('misc.unknown')
            );
        } else if (element) {
            html.push(element.Title || i18next.t('misc.unknown'));
        } else {
            html.push(i18next.t('misc.unknown'));
        }

        html.push(': ');

        if (category) {
            html.push(
                colorToHtml(category.Color || '#7E1210'),
                category.Title || i18next.t('misc.unknown')
            );
        } else {
            html.push(i18next.t('misc.unknown'));
        }

        html.push('</li>');

        return html.join('');
    }

    function temporaryDeviationToHtml(value) {
        if (value == null || isNaN(value)) {
            return '-/-';
        }

        let deviationOffsetType = i18next.t('changeMode.parameterWindow.panels.valueRanges.temporaryDeviation.waitingOffsetType.minutes');

        if (value > 0) {
            if (value % 720 === 0) {
                value = value / 1440;
                deviationOffsetType = i18next.t('changeMode.parameterWindow.panels.valueRanges.temporaryDeviation.waitingOffsetType.days');
            } else if (value % 30 === 0) {
                value = value / 60;
                deviationOffsetType = i18next.t('changeMode.parameterWindow.panels.valueRanges.temporaryDeviation.waitingOffsetType.hours');
            }
        }

        return `${value} ${deviationOffsetType}`;
    }

    function getElementsPrototypeMapping(element) {
        if (!element) {
            return null;
        }

        const prototype = changemode.Elements[element.PrototypeOID];
        let topEntity;

        if (element.Type >= 100) {
            if (!prototype) {
                // Prüfpunkt ohne Vorlage benötigt kein weiteres Mapping
                return {};
            }

            if (prototype.Parent.Type === Enums.elementType.CheckpointGroupTemplate ||
                prototype.Parent.Type === Enums.elementType.MasterdataTemplate) {
                // Kontext => Prüfgruppen- || Stammdatenvorlage bzw. aktuelle Prüfgruppe || Stammdatengruppe
                topEntity = {
                    Parametergroups: [element.Parent]
                };
            } else if (prototype.Parent.Parent.Type === Enums.elementType.FormTemplate ||
                prototype.Parent.Parent.Type === Enums.elementType.ObjectTemplate) {
                // Kontext => Formular- || Objektvorlage bzw. aktuelles Formular || OE
                topEntity = element.Parent.Parent;
            }
        } else if (element.Type >= 93) {
            if (prototype &&
                (prototype.Parent.Type === Enums.elementType.CheckpointGroupTemplate ||
                    prototype.Parent.Type === Enums.elementType.MasterdataTemplate)) {
                // Kontext => Prüfgruppen- || Stammdatenvorlage bzw. aktuelle Prüfgruppe || Stammdatengruppe
                topEntity = {
                    Parametergroups: [element]
                };
            } else {
                // Kontext => Formular- || Objektvorlage bzw. aktuelles Formular || OE
                topEntity = element.Parent;
            }
        } else if (!prototype) {
            return {};
        } else if (prototype.Parent.Parent.Type === Enums.elementType.Form ||
            prototype.Parent.Parent.Type === Enums.elementType.FormTemplate ||
            prototype.Parent.Parent.Type === Enums.elementType.ObjectTemplate ||
            prototype.Parent.Parent.Type === Enums.elementType.Root ||
            prototype.Parent.Parent.Type === Enums.elementType.Enums.elementType.Location) {
            topEntity = element;
        }

        const mapping = {};

        if (!topEntity || !topEntity.Parametergroups) {
            return mapping;
        }

        for (const group of topEntity.Parametergroups) {
            if (!!group.PrototypeOID) {
                mapping[group.PrototypeOID] = group.OID;
            }

            if (!group.Parameters || !group.Parameters.length) {
                continue;
            }

            for (const cp of group.Parameters) {
                if (!!cp.PrototypeOID) {
                    mapping[cp.PrototypeOID] = cp.OID;
                }
            }
        }

        return mapping;
    }

    function getSortedByPrototypeHierarchy(elements) {
        if ((elements || []).length <= 1) {
            return elements;
        }

        const elementMap = new Map(elements.map(element => [element.OID, element]));
        const adjacencyMap = new Map();
        const elementRankMap = new Map();

        elements.forEach(element => {
            adjacencyMap.set(element.OID, []);
            elementRankMap.set(element.OID, 0);
        });

        elements.forEach(element => {
            if (!!element.PrototypeOID && elementMap.has(element.PrototypeOID)) {
                adjacencyMap.get(element.PrototypeOID).push(element.OID);
                elementRankMap.set(element.OID, (elementRankMap.get(element.OID) || 0) + 1);
            }
        });

        const queue = [];
        elements.forEach(item => {
            if (elementRankMap.get(item.OID) === 0) {
                queue.push(item.OID);
            }
        });

        const sortedElements = [];
        while (queue.length > 0) {
            const currentOID = queue.shift();

            sortedElements.push(elementMap.get(currentOID));

            adjacencyMap.get(currentOID).forEach(childOID => {
                elementRankMap.set(childOID, elementRankMap.get(childOID) - 1);

                if (elementRankMap.get(childOID) === 0) {
                    queue.push(childOID);
                }
            });
        }

        return sortedElements;
    }

    tools.element = {
        getTypeName: getTypeName,
        prepareAdditionalProperties: prepareAdditionalProperties,
        getAdditionalPropertyValue: getAdditionalPropertyValue,
        hasCategory: hasCategory,
        isDescendant: isDescendant,
        getElementPath: getElementPath,
        formatElementCoding: formatElementCoding,
        formatElementCodingIdent: formatElementCodingIdent,
        createElementHierarchy: createElementHierarchy,
        createElementHierarchyString: createElementHierarchyString,
        createHierarchyForDownloadedElements: createHierarchyForDownloadedElements,
        getFromAdditionalSettings: getFromAdditionalSettings,
        modifyBatch: modifyBatch,
        deleteBatch: deleteBatch,
        renderElementAttributeValueToHtml: renderElementAttributeValueToHtml,
        getElementsPrototypeMapping: getElementsPrototypeMapping,
        getSortedByPrototypeHierarchy: getSortedByPrototypeHierarchy
    };
})(window.Tools || (window.Tools = {}));